const Card = {
  variants: {
    flat: {
      container: {
        bg: 'white',
        borderRadius: '12px',
        border: 'none',
        overflow: 'hidden',
        transition: 'all 0.15s ease',
      },
    },
    flatHover: {
      container: {
        bg: 'white',
        borderRadius: '12px',
        border: 'none',
        overflow: 'hidden',
        transition: 'all 0.15s ease',
        _hover: {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        },
      },
    },
    elevated: {
      container: {
        bg: 'white',
        borderRadius: '12px',
        border: 'none',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)',
        overflow: 'hidden',
        transition: 'all 0.15s ease',
      },
    },
  },
};

export default Card;
